import { LoadingSpinner } from '../loadingSpinner/loadingSpinner';

type Props = {
  onclick?: () => void;
  disabled: boolean;
  saving: boolean;
  type?: 'button' | 'submit';
};

export function SaveButton({
  onclick,
  disabled,
  saving,
  type,
}: Readonly<Props>) {
  return (
    <button
      type={type === 'submit' ? 'submit' : 'button'}
      disabled={disabled}
      onClick={onclick}
      className="text-white bg-[#2a4e50] hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none w-[15rem] disabled:opacity-70 disabled:hover:bg-[#2a4e50] flex items-center justify-center max-h-[2.5rem]"
    >
      {saving && <LoadingSpinner classToAdd="w-5 h-5" />}
      {!saving && 'Save'}
    </button>
  );
}
